import React, { useEffect, useState } from 'react';
import { back, chevron_right, gear } from '../../Images/Icons';
import { useNavigate, useParams } from 'react-router-dom';
import parse from 'html-react-parser';
import { View } from '../../Components';
import faq_json from './Faq.json';
import Accordion from '../../Components/Accordion';

const FaqDetailPage = () => {
    const navigation = useNavigate();
    const { id } = useParams();
    const [state, setAllState] = useState({ faq: {} });

    const setState = data => {
        setAllState(prevState => ({ ...prevState, ...data }));
    }

    const onGoback = () => {
        navigation(-1);
    }

    useEffect(() => {
        const _faq = faq_json.find(item => item.id == id);
        setState({ faq: _faq });
    }, []);
    
    const handleSearch = (event) => {
        const keyword = event.target.value.toLowerCase();
        const filteredFaqs = faq_json.find(item => item.id == id).faqs.filter(item => item.title.toLowerCase().includes(keyword) || item.content.toLowerCase().includes(keyword));
        setState({ faq: { ...faq, faqs: filteredFaqs } });
        if (keyword === '') {
            setState({ faq: faq_json.find(item => item.id == id) });
        }

    }
    const { faq } = state;

    return (
        <div>
            <div className="mainHeader" style={{ display: 'flex', flexDirection: 'row', justifyContent: 'start', alignItems: 'center', }}>
                <div style={{ maxWidth: 'calc(100% - 40px)', display: 'flex', margin: '0 20px', alignItems: 'center' }}>
                    <div onClick={onGoback} style={{
                        display: 'flex', justifyContent: 'center', cursor: 'pointer',
                        alignItems: 'center', width: 32, height: 32, background: 'white', borderRadius: 16
                    }}>
                        <img src={back} alt="" style={{ width: 28, height: 28 }} />
                    </div>
                    <div style={{ maxHeight: 32, whiteSpace: 'nowrap', fontSize: 18, fontWeight: 500, color: 'white', marginLeft: 12, 
                        textOverflow: 'ellipsis', overflow: 'hidden' }}>FAQ - {faq.category}</div>
                </div>
            </div>

            <div className="page-content" style={{ display: 'flex', flexDirection: 'column', flex: 1, background: '#F2F5FA' }}>
                <div style={{ display: 'flex', alignItems: 'center', margin: 20, marginBottom: 0, position:'relative' }}>
                    <input type='text' placeholder='Enter a keyword' style={{ flex: 1, margin: 0, paddingTop: 10, paddingBottom:10, paddingLeft: 15, borderRadius: 8, border: '1px solid #E0E0E0', fontSize:'12px', background: 'white' }} onChange={handleSearch} />
                    <i class="fi fi-rr-search" style={{ position: 'absolute', right: 15 }}></i>

                </div>                
                <div style={{ margin: 20, marginTop: 0 }}>
                    {
                        faq.faqs && faq.faqs.map((item, i) => (<Accordion key={`key-${i}`} style={{ marginTop: 12 }} title={item.title} content={parse(item.content)} />))
                    }
                </div>
            </div>
        </div>
    )
}

export default FaqDetailPage